import type { ChannelsTranslations } from '../interfaces/channels';

export const channelsTranslations: ChannelsTranslations = {
  page_title: 'Canales',
  page_description:
    'Conecta un canal y elige el agente que responde cuando un cliente te escribe.',

  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Chat web',
  coming_soon: 'Próximamente',
  coming_soon_description:
    'Estamos trabajando en esta integración. Te avisaremos cuando esté lista.',

  binding_title: 'Agente que responde',
  binding_description:
    'El agente seleccionado responde todos los mensajes entrantes en este canal.',
  binding_loading: 'Cargando vínculo…',
  binding_field_label: 'Agente activo',
  binding_field_placeholder: 'Elige un agente',
  binding_field_no_agents: 'Aún no tienes agentes.',
  binding_no_agents_cta: 'Crear tu primer agente',
  binding_save: 'Guardar cambios',
  binding_save_first_time: 'Vincular agente',
  binding_status_active: 'Activo',
  binding_status_inactive: 'Pausado',
  binding_status_unbound: 'Sin agente vinculado',
  binding_pause: 'Pausar respuestas',
  binding_resume: 'Reanudar respuestas',
  binding_unbind: 'Desvincular',
  binding_open_agent: 'Abrir agente',
  binding_uses_default:
    'Hereda del default ({{agent}}) hasta que vincules uno propio.',

  default_section_title: 'Default para todos los números',
  default_section_description:
    'Usado por cada teléfono de este canal salvo que lo sobrescribas abajo.',
  phones_section_title: 'Números del WABA',
  phones_section_description:
    'Cada línea puede usar el agente default o tener uno propio — útil para separar ventas y soporte.',
  phones_count: '{{count}} número',
  phone_inherits_default: 'Usa el default ({{agent}})',
  phone_no_default:
    'Sin agente default — los mensajes entrantes se descartan.',
  phone_customize: 'Personalizar',
  phone_collapse: 'Ocultar configuración propia',

  unbind_dialog_title: '¿Desvincular este canal?',
  unbind_dialog_description:
    'El número dejará de responder de inmediato. Puedes volver a vincular cuando quieras.',
  unbind_dialog_confirm: 'Desvincular',
  unbind_dialog_cancel: 'Cancelar',

  must_connect_first:
    'Conecta este canal primero para elegir el agente que responde.',

  toast_bound: 'Agente vinculado al canal.',
  toast_swapped: 'Agente activo actualizado.',
  toast_paused: 'Canal pausado.',
  toast_resumed: 'Canal reanudado.',
  toast_unbound: 'Canal desvinculado.',

  error_agent_not_found:
    'Ese agente ya no está disponible. Elige otro.',
  error_phone_not_found:
    'Ese número no está conectado a tu cuenta. Reconecta WhatsApp.',
  error_invalid_channel: 'Este canal no está soportado.',
  error_unknown: 'Algo salió mal. Inténtalo de nuevo.',
};
